/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTableNew.scss';

import React from 'react';
import { currency } from '../../../utils/dashboard-utils';
import { useSelector } from 'react-redux';
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';
import {getRMDPlusAsOf} from "../../../redux/modules/UserFunds/userFunds.selectors";

const TableTotal = (props) => {
  const { preRMDEligible } = props.rmdSummary;
   let preRMDWithAsOfSum = 0;
    props.rmdSummary.rmdAgreements.forEach((fund) => {
     preRMDWithAsOfSum += fund.currentBalance?.balance
    });
  if (props) {
    if (!preRMDEligible) {
      if (props.showYTDColumns) {
        return (
          <thead>
            <tr className="totals">
              <td className="name-total">Totals</td>
              <td className="account"></td>
              <td className="account-balance">{props.totalBalance}</td>
              <td className="year-rmd-total">{props.totalRMD}</td>
              <td className="distributions-ytd">
                {currency(props.rmdSummary.actualDistributionTotal)}
              </td>
              <td className="remaining-year">
                {currency(props.rmdSummary.totalRemainingYear)}
              </td>
              <td className="tax-ytd">
                {currency(props.rmdSummary.totalTaxWithHoldings)}
              </td>
            </tr>
          </thead>
        );
      } else {
          return (
            <thead>
            <tr className="totals">
              <td className="name-total">Total Balance</td>
              <td className="account"></td>
              <td className="account-balance">{props.totalBalance}</td>
              <td className="year-rmd-total">{props.totalRMD}</td>
            </tr>
            </thead>
          );
      }
    }
    if (preRMDEligible) {
      return (
        <thead>
        <tr className="totals">
          <td className="name-total">Totals</td>
          <td className="account"></td>
          <td className="account-balance">{currency(preRMDWithAsOfSum)}</td>
        </tr>
        </thead>
      );
    }
  }
  return null;
};

export default TableTotal;
